module.exports = __webpack_public_path__ + "static/media/yarn.3623817f.jpeg";